<ngx-spinner type="ball-atom"></ngx-spinner>
<div class="component-container">
  <div class="component-header">
    <h2>Stock Coefficients</h2>
    <div class="button-group">
      <button mat-raised-button color="primary" (click)="onStockCoefficientCorrected()" *ngIf="rightItem && matchedItems && matchedItems.length > 0">
        <mat-icon>assignment_turned_in</mat-icon>
        Correct
      </button>
      <button mat-raised-button color="primary" (click)="toggleSearch()">
        <mat-icon>search</mat-icon>
        @if (isSearchVisible) { Close search } @else { Search @if (getAppliedFiltersCount() > 0) { ({{ getAppliedFiltersCount() }}) } }
      </button>
      <button mat-raised-button color="primary" (click)="onCreateStockCoefficient()">
        <mat-icon>add</mat-icon>
        Add Stock Coefficient
      </button>
    </div>
  </div>
  <app-lookup-table-search-box
    [isSearchVisible]="isSearchVisible"
    (searchFilter)="onSearchFilterChange($event)">
  </app-lookup-table-search-box>
  <app-lookup-table
      [items]="stockCoefficients()"
      [columns]="columns"
      [enablePaging]="true"
      [enableMatching]="true"
      [pageSize]="25"
      [pageSizeOptions]="[5, 10, 25, 50]"
      (itemClick)="onItemSelected($event)"
      (editClick)="onEditStockCoefficient($event)"
      (deleteClick)="onDeleteStockCoefficient($event)"
      (itemSave)="onItemSave($event)"
      (itemAdd)="onItemAdd($event)"
      (readyToMatch)="onReadyToMatch($event)">
    </app-lookup-table>
</div>
